import type { Space, SpaceType } from '@interfaces/space.interface';

import { mockDb } from '../mock-db';

export function getSpaceTypesMock(): SpaceType[] {
  return mockDb.getSpaceTypes();
}

export function createSpaceTypeMock(data: { name: string }): SpaceType {
  return {
    id: `type-${Date.now()}`,
    name: data.name,
    description: '',
  };
}

export function getSpacesByRentalIdMock(rentalId: string): Space[] {
  return mockDb.getSpacesByRentalId(rentalId);
}

export function getSpaceByIdMock(id: string): Space | undefined {
  return mockDb.getSpaceById(id);
}

export function createSpaceMock(data?: Partial<Space>): Space {
  const base = mockDb.spaces[0];
  return { ...base, id: `space-${Date.now()}`, ...data };
}

export function updateSpaceMock(id: string, data: Partial<Space>): Space {
  const existing = mockDb.getSpaceById(id);
  const base = existing ?? mockDb.spaces[0];
  return { ...base, id, ...data };
}

export function deleteSpaceMock(): { success: boolean } {
  return { success: true };
}

export function getAllSpacesMock(): Space[] {
  return mockDb.getSpaces();
}
